// src/views/adminView/contractsView/contractsFetchAll.js
// ─────────────────────────────────────────────────────────────────────────────
// Fetch de contratos SIN paginar a ciegas: itera páginas hasta totalPages con
// tope defensivo (MAX_PAGES × limit registros). Antes se pedía page:1 limit:100
// y con 557 contratos reales se omitían 457 empresas EN SILENCIO. Si se alcanza
// el tope, `truncated: true` para que la UI muestre un aviso visible.
// Requests secuenciales (respetan el orden de páginas y no saturan la API).
// ─────────────────────────────────────────────────────────────────────────────

import { getAllContracts } from '../../../api/contracts';

export const FETCH_ALL_MAX_PAGES = 10;
export const FETCH_ALL_PAGE_LIMIT = 100;

/**
 * Trae TODOS los contratos que matcheen `params` (sin page/limit) iterando
 * páginas secuencialmente.
 * @returns {Promise<{docs: Array, error: boolean, truncated: boolean}>}
 *  - error: true si alguna página falló (docs trae lo acumulado hasta ahí).
 *  - truncated: true si había más páginas que el tope defensivo.
 */
export async function fetchAllContractPages(params = {}) {
  const docs = [];
  let page = 1;
  let totalPages = 1;

  do {
    // eslint-disable-next-line no-await-in-loop
    const response = await getAllContracts({
      ...params,
      page,
      limit: FETCH_ALL_PAGE_LIMIT,
    });
    if (!response || response.error) {
      return { docs, error: true, truncated: false };
    }
    // La API devuelve {docs, totalPages}; toleramos también {data:{docs}}.
    docs.push(...(response.docs ?? response.data?.docs ?? []));
    totalPages = response.totalPages ?? response.data?.totalPages ?? 1;
    page += 1;
  } while (page <= totalPages && page <= FETCH_ALL_MAX_PAGES);

  return { docs, error: false, truncated: totalPages > FETCH_ALL_MAX_PAGES };
}
